import Vue from 'vue'
import api from 'api'

const state = {
    currentUser: {
        persons: []
    },
    currentUserPerson: {
        texts: []
    }
};

const getters = {
};

const mutations = {
    // CURRENT_USER_UPDATED(state, {key, key2, data})  {
    //     if (!key && !key2)  {
    //         state.currentUser = data;
    //     }
    //     else if (key && !key2)  {
    //         Vue.set(state.currentUser, key, data);          
    //     }
    //     else if (key && key2)   {
    //         Vue.set(state.currentUser[key], key2, data);            
    //     }
    // },
    CURRENT_USER_UPDATED(state, userData)  {
        state.currentUser = userData;
    },
    CURRENT_USER_PERSON_UPDATED(state, personData)  {
        state.currentUserPerson = personData;
    },
    CURRENT_USER_PERSON_TEXT_LIST_UPDATED(state, personData)  {
        state.currentUserPerson = personData;
    }
};

const actions = {
    getUserFromToken({rootState}, {token, callbacks})	{
        api.getUserFromToken(rootState, token, callbacks);
    },
    getUser({rootState}, {userId, callbacks})	{
        api.getUser(rootState, userId, callbacks);
    },
    userFirstUpdate({rootState}, {userId, updateInfo, callbacks})	{
        api.userfirstUpdate(rootState, userId, updateInfo, callbacks);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};